// react
import styled from 'styled-components';
import React, { useState } from 'react';

// components
import { TextArea, Button } from '@/components/atoms';

export const Note = ({
  isReadOnly = false,
  content,
  placeholder = 'Write a note',
}: NoteProps) => {
  const [value, setValue] = useState(content);
  return (
    <StyledNoteWrapper>
      <StyledTopSection>
        <TextArea
          isDisabled={isReadOnly}
          size='sm'
          placeholder={placeholder}
          value={value}
          onChange={(val: any) => setValue(val)}
        />
      </StyledTopSection>
      {!isReadOnly && (
        <Button ariaLabel='save' variant={'secondary'} isFullWidth={true}>
          Save
        </Button>
      )}
    </StyledNoteWrapper>
  );
};

const StyledNoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
  align-items: center;
`;

const StyledTopSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[8]};
`;

interface NoteProps {
  isReadOnly?: boolean;
  content?: string;
  placeholder?: string;
}

Note.displayName = 'Note';

export default Note;
